/**
 * Removes the legacy pair-based transfer MRU key from persisted transferSettings.
 * Replaced by recentTransferSourceAccounts / recentTransferDestinationAccounts.
 */
export function removeRecentTransferAccountPairs(config: any) {
  if (config?.transferSettings?.recentTransferAccountPairs == null) {
    return;
  }

  delete config.transferSettings.recentTransferAccountPairs;
}
